import './TopBar.css';

import React from 'react';
import logo from '../../assets/images/primary_icon.svg';

interface TopBarProps {
  orgName: string;
  remainingCredits: number | '...';
}

export const TopBar: React.FC<TopBarProps> = ({ orgName, remainingCredits }: TopBarProps) => {
  const memoizedTopBar = React.useMemo(() => {
    return (
      <div
        data-testid="top-bar"
        className="top-bar bg-cds-surface-1 text-cds-on-surface-3 flex justify-between items-center pl-[20px] pr-4 h-[63px]"
      >
        <div className="flex items-center">
          <img
            src={logo}
            alt="Logo"
            className="w-[55px] h-[55px]"
          />
          <h2
            className="text-cds-on-surface-3 text-cds-3 leading-cds-3 font-normal"
            style={{
              paddingRight: 'var(--topbar-inbox-preview-padding-right, 19px)',
            }}
          >
            Inbox Preview
          </h2>
          {orgName && (
            <>
              <span
                aria-hidden="true"
                className="ml- mr-4 h-6 w-[2px] bg-cds-on-surface-3"
              />
              <span className="text-cds-on-surface-3 text-cds-3 leading-cds-3 font-normal truncate max-w-[200px]">
                {orgName}
              </span>
            </>
          )}
        </div>
        <div className="flex items-center gap-1 text-cds-on-surface-2">
          <span className="text-cds-2 leading-cds-3 font-bold">{remainingCredits}</span>
          <span className="text-cds-2 leading-cds-3 font-normal">
            previews remaining (this month)
          </span>
        </div>
      </div>
    );
  }, [orgName, remainingCredits]);

  return memoizedTopBar;
};
